"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _pick = _interopRequireDefault(require("transmute/pick"));

var _StageChangeDialog = _interopRequireDefault(require("customer-data-properties/dialog/StageChangeDialog"));

var _Promptable = _interopRequireDefault(require("UIComponents/decorators/Promptable"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _ProvideReferenceResolvers = _interopRequireDefault(require("reference-resolvers/ProvideReferenceResolvers"));

var _PropertyInputResolvers = require("customer-data-properties/resolvers/PropertyInputResolvers");

var closeDealStageProperties = ['closedate', 'closed_lost_reason', 'closed_won_reason'];
var closeTicketStageProperties = ['hs_ticket_category', 'hs_resolution'];

var _default = function _default(_ref) {
  var getPropertyInputResolver = _ref.getPropertyInputResolver,
      PropertyInput = _ref.PropertyInput,
      subject = _ref.subject,
      prevStage = _ref.prevStage,
      nextStage = _ref.nextStage,
      objectType = _ref.objectType,
      prevProperties = _ref.prevProperties,
      nextProperties = _ref.nextProperties,
      stageProperties = _ref.stageProperties,
      saveCallback = _ref.saveCallback,
      cancelCallback = _ref.cancelCallback,
      settings = _ref.settings,
      subjectProperties = _ref.subjectProperties;
  var closeStageProperties = objectType === _ObjectTypes.TICKET ? closeTicketStageProperties : closeDealStageProperties;
  var dialog = (0, _ProvideReferenceResolvers.default)((0, _PropertyInputResolvers.getPropertyInputResolverCreators)())(_StageChangeDialog.default);
  (0, _Promptable.default)(dialog)({
    nextProperties: nextProperties,
    prevStage: prevStage,
    nextStage: nextStage,
    objectType: objectType,
    prevProperties: prevProperties,
    properties: stageProperties,
    subject: subject,
    getPropertyInputResolver: getPropertyInputResolver,
    PropertyInput: PropertyInput,
    settings: settings,
    subjectProperties: subjectProperties
  }).then(function (data) {
    var allowableStages = stageProperties.map(function (prop) {
      return prop.get('property');
    }).toJS();
    var changes = (0, _pick.default)([].concat((0, _toConsumableArray2.default)(Array.from(allowableStages)), (0, _toConsumableArray2.default)(Array.from(closeStageProperties))), data);
    return saveCallback(changes);
  }, function () {
    cancelCallback();
  });
};

exports.default = _default;
module.exports = exports.default;